<template>
    <div class="border border-white">
        <div class="row">
            <div class="col-md-8">
                <h3> {{ name }}</h3>
            </div>
            <div class="col-md-4">
                <button @click="addInput" style="margin-bottom: 10px; margin-top: 12px;" type="button" class="btn btn-primary">Add target</button>
            </div>
        </div>

        <TargetInputGroup
            :key="index"
            v-for="(input, index) in inputs"
            :input="input"
            :index="index"
            :type="type"
            :target-group-options="targetGroupOptions"
            @removeInputGroup="removeInput"
        >
        </TargetInputGroup>

    </div>
</template>

<script>
import TargetInputGroup from "./TargetInputGroup";
export default {
    name: "TargetInputs",
    components: {TargetInputGroup},
    props: {
        targetGroups: {
            required: true,
            type: Array,
            default: []
        },
        type: {
            required: true,
            type: String,
            default: ''
        },
        name: {
            required: true,
            type: String,
            default: this.type
        },
        targetGroupOptions: {
            required: true,
            type: Array,
            default: [],
        },
        ownerId: {
            required: false,
            default: null
        },
        ownerDuplicatesMap: {
            required: true,
            type: Object,
        }
    },
    data() {
        return {
            inputs: [],
            selectedOwner: null
        }
    },
    mounted() {
        const ownerInput = $("#owner_id");
        this.selectedOwner = ownerInput.val();

        var that  = this;
        $("#owner_id").change(function () {
            that.selectedOwner = $(this).val()
        })
    },
    watch: {
        selectedOwner() {
            this.inputs.map(targetGroup => {
                targetGroup.duplicate_hits_percentage = this.pickDuplicatePercentage()
                return targetGroup;
            })
        }
    },
    created() {
        this.inputs = this.targetGroups.map(targetGroup => {
            targetGroup.is_enabled_for_owned_websites = targetGroup.is_enabled_for_owned_websites == "0" ? 0 : 1;
            targetGroup.is_enabled_for_traffic_code_redirect = targetGroup.is_enabled_for_traffic_code_redirect == "0" ? 0 : 1;
            targetGroup.is_enabled_for_traffic_code_static = targetGroup.is_enabled_for_traffic_code_static == "0" ? 0 : 1;
            targetGroup.daily_simulated = targetGroup.daily_simulated;
            targetGroup.duplicate_hits_percentage = null;

            if(this.type === 'mass_pixels') {
                targetGroup.is_enabled_for_server_to_server = targetGroup.is_enabled_for_server_to_server == "0" ? 0 : 1;
                targetGroup.is_enabled_for_browser = targetGroup.is_enabled_for_browser == "0" ? 0 : 1;
            }
            return targetGroup;
        });
    },

    methods: {
        addInput() {
            const input = {
                urls: '',
                is_enabled_for_browser: 0,
                is_enabled_for_server_to_server: 0,
                is_enabled_for_owned_websites: 0,
                is_enabled_for_traffic_code_redirect: 0,
                is_enabled_for_traffic_code_static: 0,
                daily_simulated: null,
                duplicate_hits_percentage: this.pickDuplicatePercentage(),
            };

            this.inputs.push(input);
        },
        removeInput(index) {
            this.inputs.splice(index, 1);
        },
        pickDuplicatePercentage() {
            const ownerMap = this.ownerDuplicatesMap[this.selectedOwner];

            if (!ownerMap) {
                return null;
            }

            const {min, max} = this.ownerDuplicatesMap[this.selectedOwner];

            if (!min || !max) {
                return null;
            }

            return Math.floor(Math.random() * (max - min + 1) + min)
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/admin/mass-target-management/TargetInputs.vue